import { SVGIconComponent } from './types';

export const AccessUnlocked: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="timeline/access-unlocked" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M18.8635981,23 L6.1364019,23 C5.50506751,23 5,22.49368 5,21.8607801 L5,10.1392199 C5,9.50631996 5.50506751,9 6.1364019,9 L18.8635981,9 C19.4949325,9 20,9.50631996 20,10.1392199 L20,21.8349578 C20,22.4935788 19.4949325,23 18.8635981,23 L18.8635981,23 Z M7.2728038,20.7215602 L17.7271962,20.7215602 L17.7271962,11.2784398 L7.2728038,11.2784398 L7.2728038,20.7215602 Z"
        id="Shape"
        fill="currentColor"
        fillRule="nonzero"
      ></path>
      <path
        d="M10,10 L7.77777778,10 L7.77777778,6.23134319 C7.77777778,4.7345038 6.71585185,3.43986868 5.25950617,3.31298347 C3.60538272,3.16032534 2.22222222,4.48073339 2.22222222,6.1549583 L2.22222222,7.42381035 C2.22222222,7.70336384 2.00038519,7.93135118 1.72839506,7.93135118 L0.49382716,7.93135118 C0.22182716,7.93135118 0,7.70335369 0,7.42381035 L0,6.28184351 C0,3.49036899 2.09876543,1.10543467 4.81481481,1.00316519 C7.65432099,0.902052911 10,3.23654782 10,6.12907372 L10,10 Z"
        id="Path"
        fill="currentColor"
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);
